<script lang="ts">
    import { onMount } from 'svelte';
    import Splide from '@splidejs/splide';
    // import '@splidejs/splide/dist/css/splide-core.min.css';
    import '@splidejs/splide/dist/css/splide.min.css';
    // import '@splidejs/splide/dist/css/themes/splide-sea-green.min.css';

    export let images: string[] = null;

    onMount(() => {
        const primarySlider = new Splide('.splide.primary', {
            rewind: true,
            width: images.length * 110,
            arrows: images.length > 1 ? true : false,
            fixedWidth: 100,
            fixedHeight: 64,
            isNavigation: true,
            gap: 10,
            pagination: false,
            cover: false,
            breakpoints: {
                '600': {
                    fixedWidth: 66,
                    fixedHeight: 40,
                },
            },
        }).mount();

        const secondarySlider = new Splide('.splide.secondary', {
            type: 'loop',
            heightRatio: 0.5,
            pagination: false,
            arrows: false,
            cover: true,
        });

        secondarySlider.sync(primarySlider).mount();
    });
</script>

<div>
    <div class="splide secondary">
        <div class="splide__track">
            <ul class="splide__list">
                {#each images as image}
                    <li class="splide__slide background-white">
                        <img src={image} alt="" />
                    </li>
                {/each}
            </ul>
        </div>
    </div>
    <div class="splide primary">
        <div class="splide__track">
            <ul class="splide__list">
                {#each images as image}
                    <li class="splide__slide background-white">
                        <img src={image} alt="" />
                    </li>
                {/each}
            </ul>
        </div>
    </div>
</div>

<style>
    .splide__slide img {
        width: 100%;
        height: 100%;
    }

    .splide {
        padding: 0em;
        margin: 0 auto;
    }

    .splide.secondary {
        margin-bottom: 30px;
    }

    .splide--nav > .splide__track > .splide__list > .splide__slide.is-active {
        border-color: var(--primary-color) !important;
    }
</style>
